"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toGoodUnit = exports.toGoodUnitMap = exports.convertStringAmountEstimate = exports.convertAmountEstimate = exports.isUnitVolumeConvertible = exports.isUnitWeight = exports.gramsPerCupMap = void 0;
const units_1 = require("../units");
const parseStringAmount_1 = require("./scaleIngredient/parseStringAmount");
const fractionize_1 = require("./fractionize");
const unitVolumeMap_1 = require("./unitVolumeMap");
exports.gramsPerCupMap = {
    basil: 20,
    butter: 227,
    flour: 128,
    "bread flour": 136,
    "cake flour": 111,
    "pastry flour": 120.5,
    "whole wheat flour": 120.5,
    "cornmeal course": 137.5,
    "cornmeal fine": 178.6,
    honey: 340,
    milk: 245,
    oats: 85,
    rice: 185,
    salt: 400,
    sugar: 201,
};
const amountRound = (n, roundToFraction) => {
    if (roundToFraction) {
        const sixteen = Math.round(n * 16) / 16;
        const third = Math.round(n * 3) / 3;
        let closer = third;
        if (Math.abs(n - third) > Math.abs(n - sixteen)) {
            closer = sixteen;
        }
        if (closer) {
            return fractionize_1.fractionize(closer);
        }
    }
    const roundedNum = Math.round(n * 10) / 10;
    if (roundedNum === 0) {
        return "" + n;
    }
    return "" + roundedNum;
};
exports.isUnitWeight = (s) => {
    return !!s && s in units_1.normalizeUnitMap && units_1.normalizeUnitMap[s] in unitVolumeMap_1.unitWeightMap;
};
exports.isUnitVolumeConvertible = (s) => {
    return (!!s && s in units_1.normalizeUnitMap && units_1.normalizeUnitMap[s] in unitVolumeMap_1.convertibleVolumes);
};
exports.convertAmountEstimate = ({ amount, currentUnit, toUnit, foodType, }) => {
    let n = amount;
    let unit = currentUnit;
    if (!(currentUnit in units_1.normalizeUnitMap)) {
        return { amount: "" + amount, unit };
    }
    currentUnit = units_1.normalizeUnitMap[currentUnit];
    if (foodType) {
        if (currentUnit in unitVolumeMap_1.unitVolumeMap && toUnit in unitVolumeMap_1.unitWeightMap) {
            const standardVolumeUnit = amount / unitVolumeMap_1.unitVolumeMap[currentUnit];
            const gramEstimate = standardVolumeUnit * exports.gramsPerCupMap[foodType];
            n = gramEstimate * unitVolumeMap_1.unitWeightMap[toUnit];
            unit = exports.toGoodUnit(n, toUnit);
        }
        else if (currentUnit in unitVolumeMap_1.unitWeightMap && toUnit in unitVolumeMap_1.unitVolumeMap) {
            const standardWeightUnit = amount / unitVolumeMap_1.unitWeightMap[currentUnit];
            const cupEstimate = standardWeightUnit / exports.gramsPerCupMap[foodType];
            n = cupEstimate * unitVolumeMap_1.unitVolumeMap[toUnit];
            unit = exports.toGoodUnit(n, toUnit);
        }
    }
    else {
        if (currentUnit in unitVolumeMap_1.unitVolumeMap && toUnit in unitVolumeMap_1.unitVolumeMap) {
            n =
                (amount / unitVolumeMap_1.unitVolumeMap[currentUnit]) *
                    unitVolumeMap_1.unitVolumeMap[toUnit];
            unit = exports.toGoodUnit(n, toUnit);
        }
        else if (currentUnit in unitVolumeMap_1.unitWeightMap && toUnit in unitVolumeMap_1.unitWeightMap) {
            n =
                (amount / unitVolumeMap_1.unitWeightMap[currentUnit]) *
                    unitVolumeMap_1.unitWeightMap[toUnit];
            unit = exports.toGoodUnit(n, toUnit);
        }
    }
    return {
        amount: amountRound(n, unit === "cup" ||
            unit === "cups" ||
            unit === "tablespoon" ||
            unit === "tablespoons" ||
            unit === "teaspoon" ||
            unit === "teaspoons"),
        unit,
    };
};
exports.convertStringAmountEstimate = ({ amount, currentUnit, toUnit, foodType, }) => {
    const [amount1, amount2] = parseStringAmount_1.parseStringAmount(amount);
    if (currentUnit !== toUnit) {
        if (typeof amount1 !== "undefined" && typeof amount2 !== "undefined") {
            const r1 = exports.convertAmountEstimate({
                amount: amount1,
                currentUnit,
                toUnit,
                foodType,
            });
            const r2 = exports.convertAmountEstimate({
                amount: amount2,
                currentUnit,
                toUnit,
                foodType,
            });
            return { amount: `${r1.amount}-${r2.amount}`, unit: r1.unit };
        }
        else if (typeof amount1 !== "undefined") {
            return exports.convertAmountEstimate({
                amount: amount1,
                currentUnit,
                toUnit,
                foodType,
            });
        }
    }
    return { amount, unit: currentUnit };
};
exports.toGoodUnitMap = {
    cup: {
        true: "cup",
        false: "cups",
    },
    liter: {
        true: "liter",
        false: "liters",
    },
    milliliter: {
        true: "ml",
        false: "ml",
    },
    ["fluid ounce"]: {
        true: "fl oz",
        false: "fl oz",
    },
    gram: {
        true: "g",
        false: "g",
    },
    kilogram: {
        true: "kg",
        false: "kg",
    },
    ounce: {
        true: "oz",
        false: "oz",
    },
    pound: {
        true: "lb",
        false: "lbs",
    },
    milligram: {
        true: "mg",
        false: "mg",
    },
    teaspoon: {
        true: "teaspoon",
        false: "teaspoons",
    },
};
exports.toGoodUnit = (amount, unit) => {
    const x = exports.toGoodUnitMap[unit];
    if (!x) {
        return unit;
    }
    return x["" + (amount === 1)] || unit;
};
//# sourceMappingURL=convertAmount.js.map